"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const CloudOff_1 = tslib_1.__importDefault(require("@mui/icons-material/CloudOff"));
const InfoOutlined_1 = tslib_1.__importDefault(require("@mui/icons-material/InfoOutlined"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Dialog_1 = tslib_1.__importDefault(require("@mui/material/Dialog"));
const DialogContent_1 = tslib_1.__importDefault(require("@mui/material/DialogContent"));
const DialogTitle_1 = tslib_1.__importDefault(require("@mui/material/DialogTitle"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const ButtonContactUs_1 = tslib_1.__importDefault(require("../ButtonContactUs"));
const CardActionsError_1 = tslib_1.__importDefault(require("../CardActionsError"));
const ExpandableTechnicalInformation_1 = tslib_1.__importDefault(require("../ExpandableTechnicalInformation"));
const TechnicalContent_1 = tslib_1.__importDefault(require("../TechnicalContent"));
const getSmallStyles = ({ theme }) => ({
    dialogContent: {
        padding: 0,
    },
    dialogTitle: {
        marginTop: theme.spacing(1),
    },
    dialogTypography: {
        whiteSpace: "pre",
    },
    icon: {
        display: "inline-flex;",
        height: "24px",
        marginBottom: theme.spacing(1),
        marginLeft: "auto",
        marginRight: theme.spacing(2),
        verticalAlign: "middle",
        width: "24px",
    },
    loading: {
        width: "100%",
    },
    nagativemMarginIcon: {
        marginLeft: "-16px",
    },
    subtitle: {},
});
const getNormalStyles = ({ theme }) => ({
    dialogContent: {
        padding: 0,
    },
    dialogTitle: {
        marginTop: theme.spacing(1),
    },
    dialogTypography: {
        whiteSpace: "pre",
    },
    icon: {
        display: "block",
        height: "136px",
        marginBottom: theme.spacing(2),
        marginLeft: "auto",
        marginRight: "auto",
        width: "136px",
    },
    loading: {
        width: "100%",
    },
    nagativemMarginIcon: {
        marginLeft: "-16px",
    },
    subtitle: {
        marginBottom: theme.spacing(1),
    },
});
const CardHttpErrorExpandable = ({ open = false, onClose, small, contact, bodyEmail, aggregatedError, argusRequestId, }) => {
    const theme = (0, styles_1.useTheme)();
    const styles = small ? getSmallStyles({ theme }) : getNormalStyles({ theme });
    const [expanded, setExpanded] = react_1.default.useState(false);
    const handleClose = () => {
        if (expanded)
            setExpanded(false);
        else
            onClose();
    };
    return (react_1.default.createElement(Dialog_1.default, { open: open, onClose: handleClose },
        react_1.default.createElement(DialogTitle_1.default, { sx: styles.dialogTitle },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1", align: small ? "left" : "center", color: "textPrimary", sx: styles.subtitle },
                react_1.default.createElement(CloudOff_1.default, { color: "disabled", sx: styles.icon }),
                "HTTP Error"),
            react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary", align: small ? "left" : "center" }, "Try to refresh the page, it might be a temporary problem"),
            react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary", align: small ? "left" : "center" }, `If the problem persists, please contact ${contact}`)),
        react_1.default.createElement(DialogContent_1.default, { sx: styles.dialogContent },
            react_1.default.createElement(ExpandableTechnicalInformation_1.default, { expanded: expanded },
                react_1.default.createElement(TechnicalContent_1.default, { aggregatedError: aggregatedError, argusRequestId: argusRequestId }))),
        react_1.default.createElement(CardActionsError_1.default, null,
            react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "space-between", alignItems: "baseline" },
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(IconButton_1.default, { size: "small", onClick: () => setExpanded(!expanded) },
                        react_1.default.createElement(InfoOutlined_1.default, null))),
                react_1.default.createElement(Grid_1.default, { item: true },
                    react_1.default.createElement(Button_1.default, { onClick: () => onClose() }, "Close"),
                    react_1.default.createElement(ButtonContactUs_1.default, { email: contact, title: "Argus bug report: HTTP Error", body: bodyEmail }))))));
};
exports.default = CardHttpErrorExpandable;
